import React from 'react'
import { Link } from 'react-router-dom'

import { ConsensusDetailsColumns } from '../../components/Shared'
import { Table } from '../../components'
import { type ConsensusRecommendationsType } from '..'

export const ConsensusRecommendationsAcutePain: React.FC = () => {
  const [selectedPageSize, setSelectedPageSize] = React.useState('1000')
  const tableData: ConsensusRecommendationsType[] = [
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Every person with sickle cell disease should have an individualized care plan that is created and updated with their SCD specialist.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Individualized care plans should be accessible in the electronic health record to patients and all other members of the care team across care settings.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Individualized care plans should be updated and reviewed with patient and/or caregiver as appropriate at least annually.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Individualized care plans should include starting dose(s), frequency, and delivery methods for initial acute pain management in the emergency department and inpatient settings.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: "Individualized care plans should have contact information for the person's sickle cell team.",
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Individualized care plans should include hydration management recommendations (e.g., when to use, fluid selection) to ensure euvolemia and avoid overhydration.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'Individualized care plans should include discharge recommendations for follow up appointments and pain management.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'Individualized Care Plan for Sickle Cell Disease',
      text: 'For individuals with known or reported (including self-report) difficult vascular access, ultrasound guided modalities should be used. The need for ultrasound guided access should be in the individualized care plan.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Inpatient components of the individualized care plan should be implemented immediately once the decision has been made to admit that patient (e.g., PCA in ED).',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Recommend the following lab work on hospital admission: - Type & Screen - CBC w/ Diff - CMP - Retic - LDH',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Hemoglobin electrophoresis may be obtained if not on file, but this should not delay management of Acute Pain Crisis.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: "While awaiting intravenous access, alternative potent analgesics should be used per the patient's individualized care plan. If an individualized care plan is not available, then alternative analgesics should be per patient preference",
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Avoid use of intravenous H1 blockers (e.g., diphenhydramine) for opioid-induced pruritic in favor of oral H1 blockers for opioid-induced pruritis.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Recommend oral over intravenous anti-emetics for management of opioid-induced nausea',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'On Presentation to the Acute Care Facility',
      text: 'Reassess that pain and analgesia every 2 hours for the first 24 hours or an effective regimen has been established. An effective regimen is ideally defined per an individualized care plan. This is to ensure analgesia is effective and safe.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'PCAs should be used as first line pain management for most patients with an acute pain crisis. Appropriateness for PCA usage is based on developmental, physical and cognitive ability.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: "Initial analgesic dosing should account for the patient's chronic outpatient opioid regimen. Ensure that daily MME is at least as much as the patient had been receiving prior to acute presentation. If possible, continue outpatient long-acting agents or suitable equivalent.",
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: "For adult patients, avoid routine use of basal infusion on PCA unless exception indicated in the patient's individualized care plan.",
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Reassess that pain and analgesia every 2 hours for the first 24 hours or an effective regimen has been established. An effective regimen is ideally defined per an individualized care plan. This is to ensure analgesia is effective and safe.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Continue disease-modifying medications during hospitalization unless clear contraindication.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Monitor total morphine milligram equivalents (MME) daily to guide acute pain management.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Non-pharmacologic and non-opioid analgesic strategies should be available and used as much as possible in conjunction with opioid therapy.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: "Avoid any increases in long-acting opioids during hospitalization unless discussed with the patient's primary SCD provider or pain management specialist.",
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Avoid use of intravenous H1 blockers (e.g., diphenhydramine) for opioid-induced pruritic in favor of oral H1 blockers for opioid-induced pruritis.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Recommend oral over intravenous anti-emetics for management of opioid-induced nausea',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Recommend use of low dose naloxone infusion as second line for opioid-induced pruritis.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Avoid overhydration in patients with sickle cell disease',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Recommend daily engagement, which could include chart review, seeing patient, etc., of a sickle cell expert during an admission for Acute Pain Crisis.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: "If a transfusion is considered, discuss with a sickle cell expert (ideally from the patient's primary sickle cell treatment center).",
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'Recommend oversedation checks with pulse oximetry every 4 hours at a minimum while on a PCA.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'If Admission to the Hospital is Required',
      text: 'For pediatric patients, recommend continuous pulse ox monitoring when on a basal rate.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'For individuals with known or reported (including self-reported) opioid refractory pain, consider addition of subanesthetic dose ketamine to opioid analgesia as part of multimodal therapy during a hospitalization.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'After 5 days of exposure to escalating doses of IV opioids without corresponding improvements in pain intensity or duration, evaluate for alternative explanations for pain as well as underlying chronic pain and/or opioid refractory pain.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'Consider management of opioid refractory pain for admission longer than 5-7 days if alternative explanations of acute pain have been evaluated without an identifiable source',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'DO NOT: routinely get a chest x-ray on admission for an acute pain crisis.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'DO NOT: routinely get an EKG on admission for uncomplicated acute pain crisis.',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'For Prolonged or Difficult to Manage Acute Pain Crisis',
      text: 'DO NOT: routinely obtain the following labs on admission: D-dimer and Haptoglobin',
      typeOfRecommendation: 'Recommendation'
    },
    {
      title: 'Discharge Planning',
      text: 'Prior to discharge, the patient needs to have a clear follow up plan and adequate pain medications for home.',
      typeOfRecommendation: 'Standard'
    },
    {
      title: 'Discharge Planning',
      text: 'Individualized care plans should include discharge recommendations for follow up appointments and pain management.',
      typeOfRecommendation: 'Recommendation'
    }
  ]

  const memoizedConsensusColumns = React.useMemo(
    () => ConsensusDetailsColumns(),
    []
  )

  React.useEffect(() => {
    const firstHeader = document.getElementById('header-1')?.closest('th')
    const secondHeader = document.getElementById('header-2')?.closest('th')
    const thirdHeader = document.getElementById('header-3')?.closest('th')
    if (firstHeader) {
      firstHeader.style.width = '20%'
    }
    if (secondHeader) {
      secondHeader.style.width = '70%'
    }
    if (thirdHeader) {
      thirdHeader.style.width = '10%'
      thirdHeader.style.paddingRight = '0.5rem'
    }
  })

  return (
    <>
      <main>
        <section className="static-page-section mt-10">
          <h1 className="pl-8 text-4xl md:text-5xl font-serif text-[#3C2416] mb-6">
            Recommendations for the Management of Uncomplicated Acute Pain
            Crisis in SCD
          </h1>
          <div className="prose prose-lg max-w-none">
            <div className="pl-8 mb-6">
              <Link
                to="https://www.dropbox.com/scl/fi/umvyv5du0nd0c2e2jz4wk/2025-Acute-Pain-Crisis-Standards-NASCC-Consensus.pdf?rlkey=qxxf0hhfvm27vqoq82hqsxnwh&st=1dlycx6s&dl=0"
                className="link-text"
              >
                Download the PDF version of this table here.
              </Link>
            </div>
            <Table
              columns={memoizedConsensusColumns}
              data={tableData}
              selectedPageSize={selectedPageSize}
              setSelectedPageSize={setSelectedPageSize}
              fetching={false}
              headerCellClassName="pl-4 py-3 text-sm font-semibold"
              customRowCellClassName="pl-4 py-3 whitespace-normal text-[#3C2416]"
              searchable={true}
            />
          </div>
        </section>
      </main>
    </>
  )
}
